import { ace, comment, loan_application } from '@axo/shared/data-access/types';
import { NonIdealState, NonIdealStateIconSize } from '@blueprintjs/core';
import { useNavigate } from 'react-router-dom';
import { useLockAndOpenApplication } from '../../hooks/utils/useLockAndOpenApplication.tsx';
import { Notification } from './Notification.tsx';
import styles from './Notifications.module.css';

function followupToNotification(
  c: comment.Comment,
): ace.Notification | undefined {
  if (!c.FollowupAt) return undefined;

  return {
    ID: 0,
    MarketCountry: c.MarketCountry,
    CreatedAt: c.FollowupAt,
    ReadAt: c.ResolvedAt,
    DeleteAt: '',
    ClientID: c.OwnerID,
    LoanApplicationID: c.LoanApplicationID,
    Title: 'Follow-up comment',
    Body: c.Body,
  };
}

export function FollowupList({
  followups,
  marketCountry,
  windowLabel,
  close,
}: {
  followups: comment.Comment[];
  marketCountry: string;
  windowLabel: string;
  close: () => void;
}) {
  const navigate = useNavigate();
  const openApplication = useLockAndOpenApplication(marketCountry);

  async function handleClick(
    followup: comment.Comment,
    loanApplication?: loan_application.LoanApplication,
  ) {
    await openApplication({
      LoanApplicationID: followup.LoanApplicationID,
      HumanReadableID: loanApplication?.HumanReadableID ?? '',
    });
    navigate(`/application/${followup.LoanApplicationID}`);
    close();
  }

  if (followups.length < 1) {
    return (
      <div className={styles.noContent}>
        <NonIdealState
          iconSize={NonIdealStateIconSize.SMALL}
          icon="time"
          title="No upcoming follow-ups"
          description={`Comments scheduled for follow-up within the ${windowLabel} will appear here.`}
        />
      </div>
    );
  }

  return (
    <div className={styles.content}>
      <div className={styles.windowLabel}>
        Showing follow-ups for the {windowLabel}
      </div>
      {followups.map((followup) => {
        const notification = followupToNotification(followup);

        if (!notification) return null;

        return (
          <Notification
            key={followup.ID}
            notification={notification}
            onClick={(loanApplication?: loan_application.LoanApplication) =>
              handleClick(followup, loanApplication)
            }
          />
        );
      })}
    </div>
  );
}
